module.exports = __webpack_public_path__ + "static/media/latestBio.19c2c840.png";